module.exports = __webpack_public_path__ + "img/showcase-hero-thumb.099c725b.png";